import React from "react";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import Switch from "Common/Custom/Switch";

// Uses `fields` prop from parent — does not re-import JSON directly
const EditRoomFacilityTypeForm = ({
  fields = [],
  values,
  errors,
  handleChange,
  handleSubmit,
  loading,
  title = "Update Room Facility Type",
}) => {
  return (
    <PageBody
      headerchildren={<HeadingOne>{title}</HeadingOne>}
      onSubmit={handleSubmit}
    >
      {fields.map((field) =>
        field.type === "switch" ? (
          <Switch
            key={field.name}
            values={values[field.name]}
            handleChange={handleChange}
            field={field}
            ValueOne="1"
            ValueTwo="0"
            LabelOne="Active"
            LabelTwo="Inactive"
          />
        ) : (
          <FormInput
            key={field.name}
            field={field}
            value={values[field.name]}
            handleChange={handleChange}
            error={errors[field.name]}
          />
        )
      )}

      <FormSubmitButton
        label="Update"
        loading={loading}
        colSize="col-12"
        align="end"
      />
    </PageBody>
  );
};

export default EditRoomFacilityTypeForm;
